import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailLabel} from '../mapping-classes/detail-label';
import {DetailPanel} from '../mapping-classes/detail-panel';

export class Tradeagreement implements DetailScreen {
  restrictedData: boolean;
  title: string;
  buttons;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;

  constructor(response: any) {
    this.title = 'Trademantelovereenkomst';
    if (response.listOfError && response.listOfError.length !== 0) {
      this.createErrorMessage(response);
    } else {
      this.restrictedData = response.detailsViewObject['restrictedData'];
      this.panels = [];
      this.nameValues = [];
      this.buttons = [];
      this.setPanels();
      this.setNameAndValues();
      this.addValues(response);
    }
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
  }

  setNameAndValues() {
    const productDetailsPanel: DetailPanel = this.panels[0];
    productDetailsPanel.nameAndValues.set('referenceNumber', new DetailLabel('Referentienummer'));

    const productAgreementsPanel: DetailPanel = this.panels[1];
    productAgreementsPanel.nameAndValues.set('serviceLevel', new DetailLabel('Service level'));
    productAgreementsPanel.nameAndValues.set('raboTradePortal', new DetailLabel('Gebruik Rabo Trade portaal'));
  }

  addValues(response) {
    const productDetailsPanel: DetailPanel = this.panels[0];
    productDetailsPanel.nameAndValues.get('referenceNumber').setValue(response.detailsViewObject.referenceNumber);

    const productAgreementsPanel: DetailPanel = this.panels[1];
    productAgreementsPanel.nameAndValues.get('serviceLevel').setValue(response.detailsViewObject.serviceLevel);
    productAgreementsPanel.nameAndValues.get('raboTradePortal').setValue(response.detailsViewObject.raboTradePortal);
  }
}
